export const SESSION_GAME_ID = 'gameId';
export const SESSION_PLAYER_ID = 'playerId';
